export const newMember = {
  newMember: "New Member",
  reconciledNewMember: "Reconciled New Member",
  search: "Search",
  username: "USERNAME",
  register: "REGISTER",
  topup: "TOPUP",
  todayFirstTopup:"First TOPUP",
  noTopup: "NO-TOPUP",
  downlineTopup: "DOWNLINE TOPUP",
  from: "From",
  to: "To",
  total: "Total",
};
